import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Separator } from "../ui/separator";
import { DateRangePicker } from "../DateRangePicker";
import { X } from "lucide-react";
import type { RecordingFiltersProps } from "./types";

export const RecordingFilters = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApplyFilters,
  onClearFilters,
  hasActiveFilters,
}: RecordingFiltersProps) => {
  return (
    <Card className="border border-border/60 bg-white/80 shadow-sm">
      <CardContent className="flex flex-wrap items-center gap-4 py-4">
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
        />
        <Separator orientation="vertical" className="h-8 hidden sm:block" />
        <div className="flex gap-2 items-center">
          <Button
            onClick={onApplyFilters}
            disabled={!hasActiveFilters}
            className="gap-2"
          >
            Apply Filters
          </Button>
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onClearFilters}
              title="Clear filters"
            >
              <X className="size-4" />
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
